import { SMALL } from "./BreakPoints.js";
/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/
export const responsiveProps = {
  spacingInset_shorthand2: {
    default: "small large",
    [SMALL]: "small medium",
  },

  spacingInset_shorthand4: {
    default: "medium large none large",
    [SMALL]: "medium medium none medium",
  },

  isMobile: {
    default: false,
    [SMALL]: true,
  },
};



// WEBPACK FOOTER //
// ./src/components/common/constant/ResponsiveProps.js